const paletteColors = require('../assets/styles/utils/palette.scss');

const paletteNames = Object
    .keys(paletteColors)
    .reduce(
        (paletteObj, paletteName) => ({
            ...paletteObj,
            [paletteName]: paletteName
        })
    , {});

export { paletteNames }